export const paths = {
  ACCOUNT: '/account',
  AD: '/ad/:id/:step/:stepId?',
  ADDRESSES: '/addresses',
  API: '/api/:tab',
  API_DOCS: '/api-docs/:tab?',
  AUTH: '/auth/:action',
  HOME: '/',
  INVITATIONS: '/invitations',
  LANGUAGE: '/:lng/*',
  LOGIN: '/login',
  LOGINS: '/logins',
  LOGOUT: '/logout',
  MESSAGES: '/messages',
  MYADS: '/ads',
  NEWACCOUNT: '/new-account',
  NEWAD: '/ad',
  PAYMENT: '/payment',
  PAYMENT_OVERVIEW: 'overview/:contractId',
  PAYMENT_PROCESSING: 'processing/:orderId',
  PRINT_QUOTE: '/print-quote/:dataObjectId',
  PRODUCTS: '/products',
  RESET: '/reset',
  SDK: '/sdk',
} as const;
